import { Injectable, Injector } from '@angular/core';
import {
  HttpInterceptor
} from '@angular/common/http';
// import { Observable } from 'rxjs';
// import { StorageService } from '~common/service/storage.service';
// import { LocalStorageConst, CULTURE_INFO } from '~common/config/constants';

@Injectable()
export class CultureInterceptor implements HttpInterceptor {

  constructor(private injector: Injector) { }

  intercept(req, next) {
    // const sessionService = this.injector.get(StorageService);
    const cultureReq = req.clone({
      setParams: {
        'culture': 'id-ID'
      }
    });

    return next.handle(cultureReq);
  }
}
